var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { tgfGraphics } from "../framework/tgfGraphics";
import { getPIXIObjectFromTbObject } from "./tbGetPIXIObject";
import { PIXI } from "./tbPIXI";
import { tbBase } from "./tbBase";
var tbNineSlice = /** @class */ (function (_super) {
    __extends(tbNineSlice, _super);
    function tbNineSlice(frame, left, top, right, bottom) {
        var _this = _super.call(this) || this;
        _this.xOrigin = 0;
        _this.yOrigin = 0;
        _this.leftWidth = left ? left : 10;
        _this.topHeight = top ? top : 10;
        _this.rightWidth = right ? right : 10;
        _this.bottomHeight = bottom ? bottom : 10;
        _this.x = 0;
        _this.y = 0;
        _this.frame = frame;
        _this.image = undefined;
        _this.alpha = 1;
        _this.scaleX = 1;
        _this.scaleY = 1;
        _this.rotation = 0;
        _this.width = _this.frame.width ? _this.frame.width : 0;
        _this.height = _this.frame.height ? _this.frame.height : 0;
        _this.image = new PIXI["mesh"]["NineSlicePlane"](_this.frame, _this.leftWidth, _this.topHeight, _this.rightWidth, _this.bottomHeight);
        return _this;
    }
    tbNineSlice.prototype.setPosition = function (x, y) {
        this.x = x;
        this.y = y;
        if (this.image) {
            this.image["x"] = this.x;
            this.image["y"] = this.y;
        }
    };
    tbNineSlice.prototype.setSize = function (width, height) {
        this.setDimensions(width, height);
    };
    tbNineSlice.prototype.setDimensions = function (width, height) {
        this.width = width;
        this.height = height;
        if (this.image && !this.image["_destroyed"]) {
            this.image["width"] = this.width;
            this.image["height"] = this.height;
        }
    };
    tbNineSlice.prototype.setAlpha = function (alpha) {
        this.alpha = Math.min(Math.max(alpha, 0), 1);
        this.image["alpha"] = this.alpha;
    };
    tbNineSlice.prototype.changeFrame = function (texture) {
        if (texture) {
            this.image["texture"] = texture;
            this.setDimensions(this.width, this.height);
            this.image["refresh"]();
        }
    };
    tbNineSlice.prototype.setTint = function (tint) {
        if (this.image) {
            this.image["tint"] = tint;
        }
    };
    tbNineSlice.prototype.setMask = function (mask) {
        if (this.image) {
            this.image["mask"] = mask;
        }
    };
    tbNineSlice.prototype.setScale = function (x, y) {
        this.scaleX = x;
        this.scaleY = y;
        if (this.image) {
            this.image["scale"]["x"] = this.scaleX;
            this.image["scale"]["y"] = this.scaleY;
        }
    };
    tbNineSlice.prototype.setRotation = function (rotation) {
        if (this.image) {
            this.image["rotation"] = rotation;
            this.rotation = rotation;
        }
    };
    tbNineSlice.prototype.gotoAndStop = function (index) {
    };
    tbNineSlice.prototype.bringToFront = function () {
        if (this.image.parent) {
            var parent_1 = this.image.parent;
            parent_1.removeChild(this.image);
            parent_1.addChild(this.image);
        }
    };
    tbNineSlice.prototype.show = function () {
        if (this.image) {
            this.image["visible"] = true;
        }
    };
    tbNineSlice.prototype.hide = function () {
        if (this.image) {
            this.image["visible"] = false;
        }
    };
    tbNineSlice.prototype.setCallback = function (callback, onDown) {
        if (onDown === void 0) { onDown = false; }
        if (this.image) {
            this.image["interactive"] = true;
            if (onDown) {
                this.image["on"]("pointerdown", callback);
            }
            else {
                this.image["on"]("pointerup", callback);
            }
        }
    };
    tbNineSlice.prototype.cancelCallback = function (call) {
        if (this.image && call && this.image["interactive"]) {
            this.image["on"]("pointerupoutside", call);
        }
    };
    /**
     * Add this image to the given container.
     * It will add itself directly to the main canvas if the container is invalid.
     */
    tbNineSlice.prototype.add = function (container) {
        if (!this.image) {
            return;
        }
        if (container === null || container === void 0 ? void 0 : container["addChild"]) {
            container["addChild"](this.image);
        }
        else {
            tgfGraphics.addChild(this.image);
        }
    };
    tbNineSlice.prototype.remove = function (container) {
        if (!this.image) {
            return;
        }
        if (container === null || container === void 0 ? void 0 : container["removeChild"]) {
            container["removeChild"](this.image);
        }
        else {
            tgfGraphics.removeChild(this.image);
        }
    };
    tbNineSlice.prototype.free = function (alsoChildren) {
        if (alsoChildren === void 0) { alsoChildren = true; }
        var options = {
            "children": alsoChildren,
            "texture": false,
            "baseTexture": false
        };
        if (this.image) {
            this.image["destroy"](options);
            this.image = null;
        }
    };
    tbNineSlice.prototype.addChild = function (child) {
        if (!this.image) {
            return;
        }
        child = getPIXIObjectFromTbObject(child);
        if (child) {
            this.image["addChild"](child);
        }
    };
    tbNineSlice.prototype.removeChild = function (child) {
        if (!this.image) {
            return;
        }
        child = getPIXIObjectFromTbObject(child);
        if (child) {
            this.image["removeChild"](child);
        }
    };
    tbNineSlice.prototype.clone = function () {
        return undefined;
    };
    return tbNineSlice;
}(tbBase));
export { tbNineSlice };
